import {useRef, useState} from 'react'
import {css} from '@emotion/react'
import useOnResize from '@/hooks/useOnResize.mjs'
import {useAiContext} from './AiContext.mjs'
import {Draft} from './Draft.jsx'
import {Messages} from './Messages.jsx'

const cssChat = css({
    position: 'relative',
    overflow: 'hidden',
})

const cssDraft = css({
    position: 'absolute',
    right: 16,
    bottom: 0,
    left: 16,
    maxWidth: 800,
    margin: 'auto',

    '&::after': {
        content: '""',
        display: 'block',
        height: 20,
        backgroundColor: '#fff',
    },
})

const cssDraftCompact = css({
    right: 8,
    left: 8,

    '&::after': {
        height: 8,
    },
})

export const Chat = ({tools, ...props}) => {
    const ai = useAiContext()
    const refElDraft = useRef()
    const [draftHeight, setDraftHeight] = useState(0)
    useOnResize(refElDraft, ({height}) => setDraftHeight(height))

    return (
        <div
            css={cssChat}
            {...props}
        >
            <Messages style={{paddingBottom: draftHeight}} />

            <div
                ref={refElDraft}
                css={[cssDraft, ai.compactView && cssDraftCompact]}
            >
                <Draft
                    tools={tools}
                />
            </div>
        </div>
    )
}
